/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMfrmUtagDataProps } from './mfrm-utag-data.props.autogenerated';

export interface IMfrmUtagDataViewProps extends IMfrmUtagDataProps<{}> {}

/**
 *
 * MfrmUtagData component
 * @extends {React.PureComponent<IMfrmUtagDataProps<{}>>}
 */
class MfrmUtagData extends React.PureComponent<IMfrmUtagDataProps<{}>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MfrmUtagData;
